import Link from "next/link";

const WhatsappFloat = () => {
    return (
        <div className="wh-api">
            <div className="wh-fixed whatsapp-pulse">
                <Link href="https://wa.me/919033939547?text=Hi,%20I’d%20like%20to%20connect%20with%20you." target="_blank">
                    <button className="wh-ap-btn"></button>
                </Link>
            </div>
        </div>
    );
};

export default WhatsappFloat;
